package com.daytimegaming.ourdailyfinances.domain.model

data class User(
    val uid: String,
    val email: String?,
)
